import { Card, Icon } from "@mui/material";
import { UserContext } from "App";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import Loader from "Loader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import CreatePatientHistoryEntryReq from "../../Classes/Models/Requests/Users/CreatePatientHistoryEntryReq";
import { v4 as uuidv4 } from "uuid";
import { LanguageContext } from "App";
import TenantManager from "Classes/API/TenantManager";
import UsersApi from "Classes/API/UsersApi";

const CreateEntry = () => {
  const { id } = useParams();
  const { translations } = useContext(LanguageContext);
  const location = useLocation();
  const { accSessionId, therapistId } = location.state || {};
  console.log("accSessionId", accSessionId, "therapistId", therapistId);
  const User = useContext(UserContext);
  const [ResponseData, setResponseData] = useState({});
  const [loading, setLoading] = useState(false);
  const [Notes, setNotes] = useState("");
  const [Files, setFiles] = useState([]);
  const [FileNames, setFileNames] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const storage = getStorage();

  // const handleSelectChange = (event) => {
  //     const selectedValue = event.target.value;
  //     // You can do something with the selected value if needed
  //     setSelectedSession(selectedValue);
  // };

  // const GetPatientSessions = async () => {

  //     let req = new SearchStringOrIntReq();
  //     req.SearchInt = id
  //     req.pagingParams.pageNumber = 1
  //     req.pagingParams.pageSize = 10000

  //     var res = await SessionsApi.GetPatientAccountingSessions(req)

  //     if (res.status == "Success") {
  //         console.log(res);
  //         setLoading(false);

  //         if (!res.data || !res.data.list || res.data.list.length === 0) {
  //             // Handle the case where data or list is null or empty
  //             setResponseData([]);
  //             return;
  //         }

  //         let tempResponseData = [...res.data.list];
  //         let userTherapistId = User.getTherapist ? User.getTherapist.id : null;

  //         if (!userTherapistId) {
  //             // Handle the case where userTherapistId is null
  //             setResponseData([]);
  //             return;
  //         }

  //         for (let i = 0; i < tempResponseData.length; i++) {
  //             if (tempResponseData[i].therapistId === userTherapistId) {
  //                 // If therapistId matches, push the item to responseData
  //                 responseData.push(tempResponseData[i]);
  //             }
  //         }

  //         setResponseData(responseData);
  //         console.log(responseData);
  //     }

  // }

  const handleSubmit = async () => {
    // debugger
    setLoading(true);
    var FilesInput = document.getElementById("HistoryEntryInput");

    var res = await SessionsApi.CreatePatientHistoryEntry2(
      Notes,
      FilesInput,
      id,
      User.therapistId != null
        ? User.therapistId
        : User.getTherapist != null
        ? User.therapistId.id
        : null,
      null
    );
    if (res.status == "Success") {
      setLoading(false);
      Swal.fire({
        title: "Success",
        text: "History Entry Created",
        icon: "success",
        confirmButtonText: "Ok",
      });
    } else {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Error Creating History Entry",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const CreateHistoryEntry = async () => {
    // setLoading(true)

    Swal.fire({
      title: "Loading",
      text: "Creating History Entry",
      icon: "info",
      showConfirmButton: false,
      allowOutsideClick: false,
    });
    var req = new CreatePatientHistoryEntryReq();

    var FilesInput = document.getElementById("HistoryEntryInput");
    var File = FilesInput?.files[0];
    console.log("File: ", File);

    if (File != null) {
      var FileData = await uploadFileData(File);
      req.FileUrl = FileData.downloadURL;
      req.FilePath = FileData.filePath;
      req.FileType = File.type;
      req.FileName = File.name;
      console.log(FileData);
    }
    req.Notes = Notes;
    req.PatientId = id;
    req.TherapistId = therapistId;
    //req.TherapistId = User.getTherapist ? User.getTherapist.id : null;
    req.AccountingSessionId = accSessionId;
    req.SessionId = selectedSession;

    console.log("req: ", req);

    var res = await SessionsApi.CreatePatientHistoryEntry2(req);
    if (res.status == "Success") {
      setLoading(false);
      Swal.fire({
        title: "Success",
        text: "History Entry Created",
        icon: "success",
        confirmButtonText: "Ok",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    } else {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Error Creating History Entry",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const uploadFileData = async (file) => {
    // Generate a unique ID
    const uniqueId = uuidv4();

    const storageRef = ref(
      storage,
      `${TenantManager.getTenant(UsersApi.GetToken())}/PatientFiles/Patient${id}/${uniqueId}`
    );
    await uploadBytes(storageRef, file);
    // Get download URL and push to downloadURLs array
    const downloadURL = await getDownloadURL(storageRef);
    console.log(downloadURL);
    return {
      downloadURL: downloadURL,
      filePath: `${TenantManager.getTenant(
        UsersApi.GetToken()
      )}/PatientFiles/Patient${id}/${uniqueId}`,
    };
  };

  useEffect(() => {
    //GetPatientSessions()
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <DashboardLayout>
      <div className="container-fluid">
        <Card sx={{ padding: "0.5em", margin: "0.5em 0 0 0" }}>
          <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
            <MDTypography variant="h6" fontWeight="medium">
              {translations.Addentry}
            </MDTypography>
            <MDButton
              onClick={() => {
                CreateHistoryEntry();
              }}
              sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
              color="success"
            >
              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
              &nbsp;{translations.Create}
            </MDButton>
          </MDBox>

          <div className="container-fluid mt-3">
            <div className="row">
              {/* <div className="col-md-3">
                                        <select id="sessionSelect" onChange={handleSelectChange}>
                                            <option value="">Select Session</option>
                                            {ResponseData.map((item) => (
                                                <option key={item.id} value={`${item.id}`}>
                                                    {`${item.sessionName} - ${new Date(item.timeStamp).toLocaleString()}`}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}

              <div className="col-md-3">
                <MDTypography variant="h6">{translations.UploadFiles}</MDTypography>
                <input type="file" id={"HistoryEntryInput"} name="files" />
              </div>

              <div className="col-md-12">
                <textarea
                  placeholder={translations.notes}
                  onChange={(e) => setNotes(e.target.value)}
                  style={{ width: "100%", minHeight: "100px", padding: "10px", marginTop: "10px" }}
                ></textarea>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default CreateEntry;
